import { CONTAINER_ID } from './entriFullPageContainer';
export const getEntriWhiteLabelConfig = _ref => {
  let {
    t,
    locale = 'en',
    fullPage = false,
    useCustomExitConfirmation = false
  } = _ref;
  const general = {
    ...(fullPage && {
      hideCloseButton: true,
      embeddedMode: {
        fillContainer: true
      }
    }),
    ...(useCustomExitConfirmation && {
      useCustomExitConfirmation: true
    })
  };
  return {
    locale,
    supportForSubdomains: false,
    whiteLabel: {
      hideProgressIndicator: true,
      hideEntriLogo: true,
      removeShareLogin: true,
      theme: {
        ...(fullPage && {
          width: '100%',
          height: '100%',
          borderRadius: '0px',
          lightBox: {
            color: 'transparent'
          }
        }),
        titles: {
          fontSize: '21px',
          providerLogin: {
            fontSize: '15px'
          }
        },
        colors: {
          inputBackground: '#F8F6F6',
          inputBorder: '#F8F6F6',
          inputText: '#151414',
          inputPlaceholder: '#767574',
          buttonPrimary: '#2F5DFF',
          buttonPrimaryText: '#FFFFFF',
          buttonSecondary: '#FFFFFF',
          buttonSecondaryText: '#2F5DFF',
          textPrimary: '#151414',
          textSecondary: '#878787'
        },
        links: '#151414',
        buttons: {
          border: {
            radius: '8px'
          }
        },
        googleFont: {
          family: 'Wix Madefor Text',
          variant: '400',
          boldWeight: '700'
        }
      },
      customProperties: {
        ...(fullPage && {
          embeddedSelector: `#${CONTAINER_ID}`
        }),
        ...(Object.keys(general).length > 0 && {
          general
        }),
        initialScreen: {
          disableScreen: true
        },
        existingRecords: {
          disableScreen: true
        },
        providerLogin: {
          hideInputIcons: true,
          showEntriToS: true,
          disableExtendedLoginAnimation: true,
          gotoManualLink: {
            replacementText: {
              en: t('entri.modal.white_label_content.replacement_text'),
              [locale]: t('entri.modal.white_label_content.replacement_text')
            }
          }
        },
        providerManualSelection: {
          disableManualScreenLink: false
        },
        manualConfiguration: {
          disableScreen: true
        },
        errorScreen: {
          genericError: {
            image: 'wix'
          },
          sessionError: {
            image: 'wix'
          }
        }
      },
      customCopy: {
        providerLogin: {
          message: {
            en: t('entri.modal.white_label.provider_login.message'),
            [locale]: t('entri.modal.white_label.provider_login.message')
          }
        },
        congratulations: {
          title: {
            en: t('entri.modal.white_label.congratulations.title')
          },
          description: {
            en: t('entri.modal.white_label.congratulations.description'),
            [locale]: t('entri.modal.white_label.congratulations.description')
          },
          button: {
            en: t('entri.modal.white_label.congratulations.cta'),
            [locale]: t('entri.modal.white_label.congratulations.cta')
          }
        },
        login2FA: {
          description: {
            generic: {
              en: t('entri.modal.white_label.login2fa.description.generic'),
              [locale]: t('entri.modal.white_label.login2fa.description.generic')
            }
          }
        }
      }
    }
  };
};
//# sourceMappingURL=entriWhiteLabelConfig.js.map